import React from 'react';
import { formatScore } from '../../constants/leaderboard';

const rankClass = (rank) => {
  if (rank === 1) return 'gold';
  if (rank === 2) return 'silver';
  if (rank === 3) return 'bronze';
  return '';
};

const LeaderboardTable = ({ rankings, myRank, currentUserId, scoreLabel, format }) => {
  if (!rankings || rankings.length === 0) {
    return (
      <div className="leaderboard-empty">
        No players qualify yet. Keep playing!
      </div>
    );
  }

  const myRankInTable = rankings.some((r) => r.userId === currentUserId);

  return (
    <>
      <div className="leaderboard-table-wrapper">
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Player</th>
              <th>{scoreLabel || 'Score'}</th>
              <th>Games</th>
            </tr>
          </thead>
          <tbody>
            {rankings.map((row) => {
              const isYou = row.userId === currentUserId;
              return (
                <tr
                  key={row.userId}
                  className={isYou ? 'leaderboard-row-you' : ''}
                >
                  <td>
                    <span className={`leaderboard-rank ${rankClass(row.rank)}`}>
                      {row.rank}
                    </span>
                  </td>
                  <td className="leaderboard-player-cell">
                    <span className="leaderboard-player-name">{row.username}</span>
                    {isYou && <span className="leaderboard-you-badge">YOU</span>}
                  </td>
                  <td>{formatScore(row.score, format)}</td>
                  <td>{row.gamesPlayed}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {!myRankInTable && myRank && (
        <div className="leaderboard-my-rank">
          Your rank: <strong>#{myRank.rank}</strong> -{' '}
          {formatScore(myRank.score, format)} ({myRank.gamesPlayed} games)
        </div>
      )}
    </>
  );
};

export default React.memo(LeaderboardTable);
